import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CONFIRM_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { getConfirmationModal } from '@commons/Modals/ConfirmationModal';

export const getDeleteTimeSlotModalParams = ({ handleDelete }) =>
  getConfirmationModal({
    type: 'warning',
    title: i18next.t('ADMIN.STORES.TIME_SLOTS_DELETE_TIME_SLOT_MODAL_TITLE'),
    icon: '/images/inpulse/trash-white-small.svg',
    content: i18next.t('ADMIN.STORES.TIME_SLOTS_DELETE_TIME_SLOT_MODAL_CONTENT'),
    actions: [
      GENERIC_MODAL_CANCEL_BUTTON(),
      {
        ...GENERIC_MODAL_CONFIRM_BUTTON(),
        handleClick: handleDelete,
      },
    ],
  });
